import { useEffect, useMemo, useSyncExternalStore } from "react";
import { MediaService } from "../services/MediaService";

export function useSiteMedia() {
  const service = useMemo(() => new MediaService(), []);
  const state = useSyncExternalStore(service.subscribeMediaTree, service.getMediaTreeState);
  useEffect(() => { void service.getMediaTree().catch(() => {}); }, [service, state.scope]);
  return { ...state, loading: state.items === undefined && state.refreshing,
    refresh: () => { void service.refreshMediaTree().catch(() => {}); } };
}
